/* eslint-disable no-unused-vars */
import { useMutation, useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { CREATE_AD_ANALYZER_NOTE } from '../../graphql/mutations';
import { GET_LIST_AD_ANALYZER_NOTE } from '../../graphql/queries';

const initLimit = 20;

const useAdAnalyzerNote = (params = {}) => {
  const { analyzerId, showNote } = params;
  const [hasMore, setHasMore] = useState(false);
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasSubmit, setHasSubmit] = useState(false);
  const [loadingFetchMore, setLoadingFetchMore] = useState(false);

  const [limit, setLimit] = useState(initLimit);
  const [offset, setOffset] = useState(0);

  const variables = () => {
    const variable = {
      limit,
      offset,
      where: {
        deleted_at: null,
        ad_analyzer_id: analyzerId,
      },
      sort: {
        created_at: 'DESC',
      },
    };
    return variable;
  };

  const { data, refetch } = useQuery(GET_LIST_AD_ANALYZER_NOTE, {
    variables: variables(),
    // skip: !showNote,
  });

  const [createNote, { loading: loadingSubmit }] = useMutation(
    CREATE_AD_ANALYZER_NOTE,
    {
      onCompleted: () => {
        setHasSubmit(true);
        setOffset(0);
        refetch();
      },
    }
  );

  useEffect(() => {
    setLoading(true);
    if (data && !hasSubmit) {
      // if (data?.GetAdSetNoteList?.data.length <= initLimit) {
      const newNotes = [
        ...data?.GetAdAnalyzerNoteList?.data.slice().reverse(),
        ...notes,
      ];
      setTimeout(() => {
        setNotes(newNotes);
      }, 200);
      // }
    } else if (data && hasSubmit) {
      setNotes(() => {
        return [...data?.GetAdAnalyzerNoteList?.data.slice().reverse()];
      });
      setHasSubmit(false);
    }
    setHasMore(data?.GetAdAnalyzerNoteList.data.length !== 0);
    setTimeout(() => {
      setLoading(false);
      setLoadingFetchMore(false);
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const fetchMore = ({ setScrollBottom }) => {
    if (notes.length !== 0 && hasMore) {
      setLoadingFetchMore(true);
      setOffset(limit);
      setLimit((prevLimit) => {
        return prevLimit + initLimit;
      });
      setScrollBottom(false);
    }
  };

  return {
    data: notes,
    loading,
    refetch,
    createNote,
    loadingSubmit,
    fetchMore,
    loadingFetchMore,
    setNotes,
  };
};

export default { useAdAnalyzerNote };
